// เมนูด้านซ้ายของหน้าแบรนด์ (ย้ายมาจาก SIDE_MENUS ใน js/brands.js)
//
// ของเดิม submenu เป็น string แล้วส่งชื่อนั้นเป็น ?sub= ตรง ๆ
// ตอนนี้ URL เป็น path จึงต้องมี slug คู่กับ label — label ยังเป็นตัวที่แสดงบนจอ
import type { Brand } from "@contracts/api";
import type { MenuIconName } from "@shared/ui/menu-icons";

export type SubMenu = { label: string; slug: string };
export type SideMenu = { id: string; label: string; icon: MenuIconName; submenu: SubMenu[] };

export const SIDE_MENUS: SideMenu[] = [
  // Overview เป็นเมนูหลักตัวแรก และเป็นหน้าที่เปิดให้เมื่อเข้าหน้าแบรนด์
  { id: "overview", label: "Overview", icon: "grid", submenu: [] },
  // ทางเข้ารายงานที่อยู่นอกเมนูปกติ — รวมไว้ที่เดียวแทนที่จะแทรกเป็นเมนูย่อยกระจัดกระจาย
  { id: "discover", label: "Discover", icon: "compass", submenu: [] },
  // Campaigns ต้องอยู่ในเมนูย่อยด้วย ไม่ใช่มีแต่ AdWatch — เมนูที่มีเมนูย่อยกดที่หัวข้อ
  // แล้วกาง/หุบ ไม่ได้เข้าหน้า ถ้าไม่มีบรรทัดนี้ตารางแคมเปญจะไม่มีทางเข้าจากแถบซ้าย
  // (KOL / Online Ads ยังเข้าจากลิงก์ในตาราง ไม่ใช่จากแถบซ้าย เหมือนเดิม)
  {
    id: "ads",
    label: "Ads Campaigns",
    icon: "megaphone",
    submenu: [
      { label: "Campaigns", slug: "campaigns" },
      { label: "AdWatch", slug: "adwatch" },
    ],
  },
  { id: "message", label: "Messages", icon: "chat", submenu: [] },
  { id: "finance", label: "Finance", icon: "wallet", submenu: [] },
  // เดิมชื่อ Strategy แต่ไม่เคยมีหน้าของตัวเอง (ตกไปที่ dashboard กลาง)
  { id: "brand-asset", label: "Brand & Competitors", icon: "target", submenu: [] },
  { id: "data", label: "Data", icon: "chart", submenu: [] },
  // ใครเข้าถึงแบรนด์นี้ได้บ้าง — เห็นได้ทุกคนที่เข้าถึงแบรนด์นี้ ส่วนคนที่ถือสิทธิ์ manage
  // เพิ่ม/ถอดคนอื่นได้เองจากหน้านี้ โดยไม่ต้องผ่าน Setting ซึ่งเปิดได้แค่ Admin
  { id: "team", label: "Team", icon: "users", submenu: [] },
];

/**
 * เมนูที่แสดงจริงสำหรับแบรนด์นี้ — ปิด feature ไว้ = เมนูที่ดึงเนื้อหานั้นมาแสดงจะหายไป
 * (ตั้งค่าที่ Setting → Channels & Inbox → ดึงเนื้อหามาแสดงในเมนูไหน)
 */
export function visibleMenus(brand: Brand): SideMenu[] {
  const f = brand.features || {};
  const on = (k: keyof typeof f) => f[k] !== false;
  return SIDE_MENUS.filter((m) => {
    if (m.id === "message") return on("inbox");
    return true;
  });
}

export type FeatureOff = { label: string; crumb: string };

/** เมนูนี้ถูกปิดการดึงเนื้อหาไว้หรือไม่ — คืนรายละเอียดไว้ทำข้อความ ถ้าเปิดอยู่คืน null */
export function featureOffFor(brand: Brand, menuId: string, sub?: string): FeatureOff | null {
  const f = brand.features || {};
  const off = (k: keyof typeof f) => f[k] === false;
  if (menuId === "message" && off("inbox")) return { label: "Inbox", crumb: "Messages" };
  if (menuId === "content" && (!sub || sub === "calendar") && off("content"))
    return { label: "Content Calendar", crumb: "Content Calendar" };
  if (menuId === "analytics" && off("report"))
    return { label: "Report", crumb: "Analytics / Facebook Inbox" };
  return null;
}

/** ลิงก์ไปหน้าตั้งค่าของแบรนด์นี้ — สินค้าเดี่ยวกับกลุ่มอยู่คนละเมนู */
export function brandCfgLink(brand: Brand): string {
  return brand.kind === "group"
    ? `/setting/group/${encodeURIComponent(brand.id)}`
    : `/setting/product/${encodeURIComponent(brand.id)}`;
}

/** path ของเมนู/เมนูย่อยในหน้าแบรนด์ */
export function menuPath(brandId: string, menuId: string, subSlug?: string): string {
  const base = `/brand/${encodeURIComponent(brandId)}/${menuId}`;
  return subSlug ? `${base}/${subSlug}` : base;
}
